import React from 'react';
import { number, bool } from 'prop-types';
import { Row } from '@thd-olt-component-react/core-ui';
import { TOTAL_TEXT } from '../../../constants';
import '../shared-summary.scss';

export const Total = ({ freeShipping, mapExists, deliveryFee, totalPrice }) => {
  let totalText = TOTAL_TEXT.UNKNOWN;
  if (freeShipping) totalText = TOTAL_TEXT.FREE;
  if (deliveryFee) totalText = `$${(deliveryFee.toFixed(2))}`;

  return (
    <Row className="package-pricing__section">
      <Row className="package-pricing__row">
        {(freeShipping || deliveryFee) ? (
          <>
            <span>Delivery</span>
            <span className="package-pricing__success" data-testid="package-delivery">{totalText}</span>
          </>
        ) : (
          <>
            <span>Delivery (calculated in cart)</span>
            <span data-testid="package-delivery">{totalText}</span>
          </>
        )}
      </Row>
      <Row className="package-pricing__row">
        <span>Taxes (calculated in checkout)</span>
        <span>-</span>
      </Row>
      <Row className="package-pricing__row">
        <span>Total</span>
        {!mapExists ? (
          <span className="u__bold" data-testid="package-total">
            ${(totalPrice.toFixed(2))}
          </span>
        ) : (
          <span>-</span>
        )}
      </Row>
    </Row>
  );
};

Total.propTypes = {
  freeShipping: bool.isRequired,
  mapExists: bool.isRequired,
  totalPrice: number.isRequired,
  deliveryFee: bool
};

Total.defaultProps = {
  deliveryFee: 0
};
